export const json = (value) => {
    if (typeof value === 'string' && value.length) {
        try {
            JSON.parse(value)
        } catch (error) {
            return { success: false, error: error }
        }
    }
    return { success: true }
}

export const scss = (value) => {
    return { success: true }
}

export default {
    scss,
    json
}